/**
 * DERIVED VEHICLE PRESENCE UTILITY
 * 
 * Replaces the legacy `vehicle_present` boolean column with a derived check.
 * A vehicle is considered present if it is:
 * - In a parking spot (parking_spot_id set)
 * - In a bay (bay_id set)
 * - Has an active timer (running or paused)
 * - In the parking lot (parking_lot = true)
 * 
 * The `vehicle_present` column remains as a transitional DB mirror but is
 * NO LONGER authoritative. All app logic must use this function.
 * 
 * NOTE: The DB trigger `sync_vehicle_present` includes the same conditions
 * including parking_lot. This helper MUST stay in sync with that trigger.
 */

export function isVehiclePresent(ticket: {
  parking_spot_id?: string | null;
  bay_id?: string | null;
  timer_status?: string | null;
  parking_lot?: boolean | null;
}): boolean {
  return !!(
    ticket.parking_spot_id ||
    ticket.bay_id ||
    ticket.timer_status === 'running' ||
    ticket.timer_status === 'paused' ||
    ticket.parking_lot
  );
}
